import {
    AfterContentInit,
    AfterViewInit,
    Component,
    OnInit,
    ViewChild,
} from "@angular/core";
import { NgForm } from "@angular/forms";
import { Booking } from "../../../Modals/booking.model";
import { FormService } from "../../common/services/form.service";
import { ModalService } from "../../common/services/modal.service";
import { DatePipe } from "@angular/common";
import { ApiService } from "../../common/services/api.service";
import { SwitchLanguageService } from "../../common/services/switch-language.service";
import { Router } from "@angular/router";
@Component({
    selector: "app-request-booking",
    templateUrl: "./request-booking.component.html",
    styleUrls: ["./request-booking.component.scss"],
})
export class RequestBookingComponent implements OnInit, AfterViewInit {
    birthDate: string = "";
    shortLink: string = "";
    loading: boolean = false; // Flag variable
    file: File = null; // Variable to store file
    forms: NgForm[] = [];
    booking: Booking = new Booking();
    dateOfBirth: Date = new Date();

    @ViewChild("bookingForm") bookinForm: NgForm;

    sameUser: boolean = false;
    indeterminate = false;

    constructor(
        private formService: FormService,
        private modal: ModalService,
        public datepipe: DatePipe,
        private apiService: ApiService,
        private switchLang: SwitchLanguageService,
        private router: Router
    ) {}

    ngOnInit(): void {}

    onChangeIDPhoto(event) {
        this.booking.idPhoto = event.target.files[0];
    }

    onChangeMedicalReport(event) {
        this.booking.medical_report = event.target.files[0];
    }

    onChangeRadiology(event) {
        this.booking.radiology = event.target.files[0];
    }

    onChangeRetina(event) {
        this.booking.retina = event.target.files[0];
    }

    ngAfterViewInit(): void {
        this.forms.push(this.bookinForm);
        console.log(this.bookinForm.controls);
    }

    onUpload() {
        // this.loading = !this.loading;
        // console.log(this.file);
        // this.fileUploadService.upload(this.file).subscribe((event: any) => {
        //     if (typeof event === "object") {
        //         this.shortLink = event.link;
        //         this.loading = false; // Flag variable
        //     }
        // });
    }

    requestBooking() {
        console.log(this.forms);
        let isValid = this.formService.validateForm(this.forms);

        if (!isValid) {
            this.modal.openValidationDialog(
                "warning",
                "خطأ",
                "يرجي ملئ البيانات المطلوبه"
            );
            return;
        }

        if (this.sameUser) this.booking.main_patient = "1";
        else this.booking.main_patient = "0";

        let latest_date = this.datepipe.transform(
            this.dateOfBirth,
            "yyyy-MM-dd"
        ); 

        this.booking.dateofbirth = latest_date;

        this.apiService.requestBooking(this.booking).subscribe((res: any) => {
            //console.log(res);
            this.router.navigate(["/patient-account"]);
            this.modal.snackMessage("جاري متابعة طلب الحجز...");
            if (res && res["success"] == true) {
                if (this.switchLang.getCurrentLang() == "ar") {
                    this.modal.snackMessage("جاري متابعة طلب الحجز...");
                } else {
                    this.modal.snackMessage(
                        "The booking request is being tracked..."
                    );
                }
            }else{
                this.modal.snackMessage(res["message"]);
                    return;
            }
        },
        (error) => {
            //this.loading = false;
            this.modal.snackMessage(error["error"].error);
        });
    }
}
